import React from 'react';
import PropTypes, { any } from 'prop-types';

import { dictFromArrayByProp } from '../../../utils';
import { sportTypeIds } from '../../../utils/eventConstants';

import styles from './teamStandingsCardV3.scss';

const statsTypes = {
    TOTAL_MATCHES: 'TOTAL_MATCHES',
    MATCH_WIN_LOSS: 'MATCH_WIN_LOSS',
    SET_WIN_LOSS: 'SET_WIN_LOSS',
    GAME_WIN_LOSS: 'GAME_WIN_LOSS',
};

const statTestKeys = {
    [statsTypes.TOTAL_MATCHES]: 'total-matches',
    [statsTypes.MATCH_WIN_LOSS]: 'match-win-loss',
    [statsTypes.SET_WIN_LOSS]: 'set-win-loss',
    [statsTypes.GAME_WIN_LOSS]: 'game-win-loss',
};

function Stats(props) {
    const { force = {}, dividerIndex = 4, isDoubleElimination, isFeedInBackDraw, isFirstMatchBackDraw, childDrawStats, sportTypeId, 'data-testid': dataTestId } = props;
    let { stats } = props;

    const statsObj = stats ? dictFromArrayByProp(stats, 'type') : {};
    const childDrawStatsObj = childDrawStats ? dictFromArrayByProp(childDrawStats, 'type') : {};
    const isPickleball = sportTypeId === sportTypeIds.PICKLEBALL;
    const labelDict = {
        TOTAL_MATCHES: 'Matches',
        GAME_WIN_LOSS: isPickleball ? 'Pts rec.' : 'Games',
        MATCH_WIN_LOSS: 'Record',
        SET_WIN_LOSS: isPickleball ? 'Games' : 'Sets',
    };
    stats = stats && stats.map(stat => {
        return labelDict[stat.type] ? stat : null;
    }).filter(s => s !== null);

    const statsOrder = [
        statsTypes.TOTAL_MATCHES,
        statsTypes.MATCH_WIN_LOSS,
        statsTypes.SET_WIN_LOSS,
        statsTypes.GAME_WIN_LOSS,
    ];

    if (force.cardView) {
        return (
            <>
                {statsOrder.map((statLabel, i) => {
                    const stat = statsObj[statLabel];
                    const { category, type, count, wins, losses } = stat || {};
                    return stat ? (
                        <React.Fragment key={`stat-${stat.type}`}>
                            {i === dividerIndex && <div className="div mt8 mb8" />}
                            <div className={'col'}>
                                <div className={styles.statLabel} data-testid={dataTestId && `${dataTestId}.${statTestKeys[type]}.label`}>
                                    {labelDict[type]}
                                </div>
                                <div className={styles.statValue} data-testid={dataTestId && `${dataTestId}.${statTestKeys[type]}.value`}>
                                    {category === 'COUNT' ? count : `${wins} - ${losses}`}
                                </div>
                            </div>
                        </React.Fragment>
                    ) : null;
                })}
            </>
        );
    }

    if (isDoubleElimination || isFeedInBackDraw || isFirstMatchBackDraw) {
        return (
            <>
                <div className={`col d-flex jcc aic`}>
                    {statsObj.TOTAL_MATCHES && (
                        <div className="values" data-testid={dataTestId && `${dataTestId}.total-matches`}>
                            {statsObj.TOTAL_MATCHES.count + (childDrawStatsObj.TOTAL_MATCHES?.count || 0)}
                        </div>
                    )}
                </div>
                <div className={`col d-flex jcc aic`}>
                    {statsObj.MATCH_WIN_LOSS && (
                        <div className="values" data-testid={dataTestId && `${dataTestId}.match-win-loss`}>
                            {statsObj.MATCH_WIN_LOSS.wins} - {statsObj.MATCH_WIN_LOSS.losses}
                        </div>
                    )}
                </div>
                <div className={`col d-flex jcc aic`}>
                    {childDrawStatsObj.MATCH_WIN_LOSS && (
                        <div className="values" data-testid={dataTestId && `${dataTestId}.child-match-win-loss`}>
                            {childDrawStatsObj.MATCH_WIN_LOSS.wins} - {childDrawStatsObj.MATCH_WIN_LOSS.losses}
                        </div>
                    )}
                </div>
                <div className={`col d-flex jcc aic`}>
                    {statsObj.SET_WIN_LOSS && (
                        <div className="values" data-testid={dataTestId && `${dataTestId}.set-win-loss`}>
                            {statsObj.SET_WIN_LOSS.wins + (childDrawStatsObj.SET_WIN_LOSS?.wins || 0)} - {statsObj.SET_WIN_LOSS.losses + (childDrawStatsObj.SET_WIN_LOSS?.losses || 0)}
                        </div>
                    )}
                </div>
                <div className={`col d-flex jcc aic`}>
                    {statsObj.GAME_WIN_LOSS && (
                        <div className="values" data-testid={dataTestId && `${dataTestId}.game-win-loss`}>
                            {statsObj.GAME_WIN_LOSS.wins + (childDrawStatsObj.GAME_WIN_LOSS?.wins || 0)} - {statsObj.GAME_WIN_LOSS.losses + (childDrawStatsObj.GAME_WIN_LOSS?.losses || 0)}
                        </div>
                    )}
                </div>
            </>
        );
    }

    return (
        <>
            <div className={`col d-flex jcc aic`}>
                {statsObj.TOTAL_MATCHES && (
                    <div className="values" data-testid={dataTestId && `${dataTestId}.total-matches`}>
                        {statsObj.TOTAL_MATCHES.count}
                    </div>
                )}
            </div>
            <div className={`col d-flex jcc aic`}>
                {statsObj.MATCH_WIN_LOSS && (
                    <div className="values" data-testid={dataTestId && `${dataTestId}.match-win-loss`}>
                        {statsObj.MATCH_WIN_LOSS.wins} - {statsObj.MATCH_WIN_LOSS.losses}
                    </div>
                )}
            </div>
            <div className={`col d-flex jcc aic`}>
                {statsObj.SET_WIN_LOSS && (
                    <div className="values" data-testid={dataTestId && `${dataTestId}.set-win-loss`}>
                        {statsObj.SET_WIN_LOSS.wins} - {statsObj.SET_WIN_LOSS.losses}
                    </div>
                )}
            </div>
            <div className={`col d-flex jcc aic`}>
                {statsObj.GAME_WIN_LOSS && (
                    <div className="values" data-testid={dataTestId && `${dataTestId}.game-win-loss`}>
                        {statsObj.GAME_WIN_LOSS.wins} - {statsObj.GAME_WIN_LOSS.losses}
                    </div>
                )}
            </div>
        </>
    );
}

Stats.propTypes = {
    force: PropTypes.objectOf(any),
    dividerIndex: PropTypes.number,
    isDoubleElimination: PropTypes.bool,
    isFeedInBackDraw: PropTypes.bool,
    isFirstMatchBackDraw: PropTypes.bool,
    childDrawStats: PropTypes.arrayOf(any),
    'data-testid': PropTypes.string,
};

Stats.defaultProps = {
    force: {},
    dividerIndex: 4,
    isDoubleElimination: false,
    isFeedInBackDraw: false,
    isFirstMatchBackDraw: false,
    childDrawStats: [],
    'data-testid': null,
};

export default Stats;
